/* EDIT SOFTSKILL COURSE */
export const EDIT_SOFTSKILL_COURSE = "EDIT_SOFTSKILL_COURSE"
export const EDIT_SOFTSKILL_COURSE_SUCCESS = "EDIT_SOFTSKILL_COURSE_SUCCESS"
export const EDIT_SOFTSKILL_COURSE_CLEAN = "EDIT_SOFTSKILL_COURSE_CLEAN"
export const EDIT_SOFTSKILL_COURSE_ERROR = "EDIT_SOFTSKILL_COURSE_ERROR"
